import React from 'react';
import {
    ControlsCell,
    DateCell,
    Indicator,
    ProductCell,
    StatusCell,
    Wrapper,
} from './card-approval-employee-request-preview.styles';
import { CardApprovalEmployeeRequestPreviewProps } from './types';
import { Typography } from '../../../../shared/ui/typography/typography';

export const CardApprovalEmployeeRequestPreview: React.FC<CardApprovalEmployeeRequestPreviewProps> = ({
    date,
    productName,
    children,
}) => {
    return (
        <Wrapper>
            <StatusCell>
                <Indicator />
            </StatusCell>
            <DateCell>
                <Typography size='body2_long' color='neutral_50'>
                    Дата
                </Typography>
                <Typography size='body2_long' color='neutral_90'>
                    {date}
                </Typography>
            </DateCell>
            <ProductCell>
                <Typography size='body2_long' color='neutral_50'>
                    Название
                </Typography>
                <Typography size='body2_long' color='neutral_90'>
                    {productName}
                </Typography>
            </ProductCell>
            <ControlsCell>{children}</ControlsCell>
        </Wrapper>
    );
};
